export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const decoded = decodeURIComponent(escape(window.atob(base64)));

  return JSON.parse(decoded);
};
